import { themeColors } from "../../../themeColors";
/**
 * @file   src\mobile\components\SendIntroduction\SelectPaymentMethod.js
 * @brief  This file is responsible for select payment method before send introduction in mobile view
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useEffect } from "react";
import "../../styles/clients.scss";
import {
  getCardIconForIntroduction,
  isDateInThePast,
  setBodyBackgroundGrey,
} from "../../../helpers/common";
import TopHeader from "../common/TopHeader";
import BackLinkButton from "../../components/BackLinkButton";
import { usePremium } from "@/hooks";

import { ADD_PAYMENT, REVIEW_ORDER } from "../../../constants/onBoarding";

const SelectPaymentMethod = (props) => {
  const { updateCardParam, setUIKey } = props;
  useEffect(() => {
    setBodyBackgroundGrey();
    document.body.classList.add("bg-offcanvas-fix");
  }, []);

  const userPaymentMethods = props.paymentMethods;
  const selectedCardId = props.selectedCardId;

  const { shouldToggleColor } = usePremium();

  const handleRadioButtonChange = (paymentMethod) => {
    updateCardParam(paymentMethod);
    setUIKey(REVIEW_ORDER);
  };

  return (
    <div className="gitcha-main-wrapper view-client-wrap select-payment-wrap pb-102">
      <div className="content-wrapper content-wrapper-h-102-percent">
        <TopHeader
          variant={"review"}
          outerClassname="bg-white"
          topClassName="header-brdr-btm w-100"
          bottomClassName="signup-header-txt clearfix"
        >
          <BackLinkButton
            variant="small"
            shouldToggleColor={shouldToggleColor}
            onClick={() => {
              props.setUIKey(REVIEW_ORDER);
            }}
          />
          <span className={shouldToggleColor ? "heading-premium" : "heading"}>
            Select Payment Method
          </span>
        </TopHeader>
        <div className="inner-layout-content-new bg-white">
          <div className="modal-choose-property mb-0">
            {userPaymentMethods &&
              userPaymentMethods.length > 0 &&
              userPaymentMethods?.map((paymentMethod) => {
                let expired = isDateInThePast(
                  paymentMethod?.Exp_Month,
                  paymentMethod?.Exp_Year,
                );
                return (
                  <label className="property-radio">
                    {!expired && (
                      <input
                        type="radio"
                        name="check-box-option"
                        id={paymentMethod?.CardId}
                        value={paymentMethod?.CardId}
                        checked={
                          paymentMethod?.Payment_Mode_Id == selectedCardId
                            ? true
                            : false
                        }
                        onClick={() => handleRadioButtonChange(paymentMethod)}
                      />
                    )}
                    <span className="bdrRadius-0">
                      <div className="card-icon">
                        {" "}
                        <img
                          src={getCardIconForIntroduction(paymentMethod?.Brand)}
                          alt=""
                        />
                      </div>
                      <div className="card-name">
                        <h4>
                          {paymentMethod?.Brand} •••••••••••••
                          {paymentMethod?.Last4}{" "}
                        </h4>
                        {expired ? (
                          <p className="m-0">
                            Expired{" "}
                            {String(paymentMethod?.Exp_Month).padStart(2, "0")}/
                            {String(paymentMethod?.Exp_Year).slice(-2)}
                          </p>
                        ) : (
                          <p className="m-0">
                            Exp.{" "}
                            {String(paymentMethod?.Exp_Month).padStart(2, "0")}/
                            {String(paymentMethod?.Exp_Year).slice(-2)}
                          </p>
                        )}
                      </div>
                    </span>
                  </label>
                );
              })}
          </div>
        </div>
      </div>
      <div className="inner-layout-footer-new">
        <div className="inner-btm-fixed-nav">
          <div className="btn-wrap">
            <button
              type="button"
              className="btn btn-light w-100 btn-ico-flex"
              onClick={() => {
                setUIKey(ADD_PAYMENT);
              }}
            >
              Add Debit/Credit Card <i className="add-ico"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectPaymentMethod;
